module.exports = __webpack_public_path__ + "static/media/street-view.e172788e.svg";